import { render, staticRenderFns } from "./EmployeesByGender.vue?vue&type=template&id=3b30b4cd&scoped=true&"
import script from "./EmployeesByGender.vue?vue&type=script&lang=js&"
export * from "./EmployeesByGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b30b4cd",
  null
  
)

export default component.exports